import Model from '~/models/Model';

export default class EmailLayout extends Model {
  resource() {
    return 'v1/email-layouts';
  }
}
